/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsVectorCircleOnePoint: {
  name: 'vector-circle-one-point';
  data: string;
} = {
  name: 'vector-circle-one-point',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M2.5 8a5.5 5.5 0 0 1 10.625-2H13a1.5 1.5 0 0 0-1.5 1.5v1A1.5 1.5 0 0 0 13 10h.125A5.502 5.502 0 0 1 2.5 8Zm11.659 1.992a.499.499 0 0 1-.029.175 6.5 6.5 0 1 1 0-4.333.5.5 0 0 1 .029.174A1.5 1.5 0 0 1 15.5 7.5v1a1.5 1.5 0 0 1-1.341 1.492ZM12.5 7.5A.5.5 0 0 1 13 7h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1Z" fill="currentColor"/></svg>`,
};
